import * as datadogRum from 'lib/telemetry/datadogRum';

/**
 * Returns the current Datadog RUM session/view ids if RUM has initialized.
 *
 * Used as a join key on funnel events (e.g. deposit, KYC) so downstream
 * pipelines can correlate per-event rows with RUM session-level signals
 * (frustration_count, rage_clicks, dead_clicks, error_count).
 *
 * Returns an empty object when RUM has not yet initialized or is unavailable
 * (e.g. SSR, ad-blocker). Callers should spread the result into the event
 * property bag so the keys are simply absent rather than `undefined`.
 */
export function getRumContext(): { rum_session_id?: string; rum_view_id?: string } {
    try {
        const ctx = datadogRum.getInternalContext();
        if (!ctx) return {};
        return {
            rum_session_id: ctx.session_id,
            rum_view_id: ctx.view?.id,
        };
    } catch {
        return {};
    }
}
